export const API_URL = 'https://api-retail.connectpos.com'
export const DOMAIN_TITLE = 'Reports Connectpos'
export const API_VERSION = 'v0'
export const API_VERSION_1 = 'v1'
export const API_ORDER_URL = 'https://api-order.connectpos.com'
export const API_REPORT_URL = 'https://api-daily.connectpos.com'
export const API_SETTING_URL = 'https://api-setting.connectpos.com'
export const API_CATALOG = 'https://api-catalog.connectpos.com'
export const API_CUSTOMER = 'https://api-customer.connectpos.com'
